import React, { useEffect, useRef } from "react";
import "./Homepages.css";
import BlackRothAnimation from "./BlackRothAnimation";
import SEO from "./seo/SEO";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "BlackRoth",
  url: "https://blackroth.in/",
  logo: "https://blackroth-images.s3.ap-south-1.amazonaws.com/BlackRoth1.png",
  sameAs: [
    "https://in.linkedin.com/company/blackroth",
    "https://x.com/BlackRothPvtLtd",
  ],
  contactPoint: [
    {
      "@type": "ContactPoint",
      contactType: "customer support",
      email: "info@blackroth.in",
      areaServed: "IN",
      availableLanguage: ["en"],
    },
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress:
      "12B, BLACKROTH, THE HEADQUARTERS, 6TH FLOOR, ORBIT, KNOWLEDGE CITY, RAIDURG",
    addressLocality: "Hyderabad",
    addressRegion: "Telangana",
    postalCode: "500019",
    addressCountry: "IN",
  },
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  url: "https://blackroth.in",
  name: "BlackRoth",
};

const Homepages = () => {
  const storyRef = useRef(null);

  const updateExpertisePointer = (event) => {
    const card = event.currentTarget;
    const bounds = card.getBoundingClientRect();
    const relativeX = (event.clientX - bounds.left) / bounds.width;
    const relativeY = (event.clientY - bounds.top) / bounds.height;
    const shiftX = (relativeX - 0.5) * 18;
    const shiftY = (relativeY - 0.5) * 14;
    const rotateY = (relativeX - 0.5) * 14;
    const rotateX = (0.5 - relativeY) * 12;

    card.style.setProperty("--pointer-x", `${relativeX * 100}%`);
    card.style.setProperty("--pointer-y", `${relativeY * 100}%`);
    card.style.setProperty("--shift-x", `${shiftX.toFixed(2)}px`);
    card.style.setProperty("--shift-y", `${shiftY.toFixed(2)}px`);
    card.style.setProperty("--rotate-x", `${rotateX.toFixed(2)}deg`);
    card.style.setProperty("--rotate-y", `${rotateY.toFixed(2)}deg`);
  };

  const resetExpertisePointer = (event) => {
    const card = event.currentTarget;
    card.style.setProperty("--pointer-x", "50%");
    card.style.setProperty("--pointer-y", "50%");
    card.style.setProperty("--shift-x", "0px");
    card.style.setProperty("--shift-y", "0px");
    card.style.setProperty("--rotate-x", "0deg");
    card.style.setProperty("--rotate-y", "0deg");
  };

  // Story Section Animation
  useEffect(() => {
    const currentStory = storyRef.current;

    if (!currentStory) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const storyContent = entry.target.querySelector(".story-content");
            const storyTitle = entry.target.querySelector(".story-title");
            const storyText1 = entry.target.querySelector(".story-text-1");
            const storyText2 = entry.target.querySelector(".story-text-2");
            const storyImage = entry.target.querySelector(".story-image");

            storyContent?.classList.add("animate");
            storyTitle?.classList.add("animate");
            storyText1?.classList.add("animate");
            storyText2?.classList.add("animate");
            storyImage?.classList.add("animate");
          }
        });
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    observer.observe(currentStory);

    return () => {
      observer.unobserve(currentStory);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <SEO schema={organizationSchema} />
      <SEO schema={websiteSchema} />
      <section className="about-us">
        <div className="about-container">
          <div className="about-header">

            <p className="about-subtitle">
              A dynamic pioneering the future of technology through innovation, 
                   fresh perspectives, and unwavering commitment to excellence, 
              driven by a passion to solve real-world challenges, empower communities,
               and redefine industry standards through cutting-edge solutions and collaborative ingenuity.
            </p>
          </div>

          <div className="about-content">
            <div className="about-grid">
              <div className="about-card">
                <h3>Our Mission</h3>
                <p>
                  To empower businesses with cutting-edge technology solutions that
                  drive growth, efficiency, and competitive advantage.
                </p>
              </div>

              <div className="about-card">
                <h3>Our Vision</h3>
                <p>
                  To be the leading technology partner that transforms ideas into
                  reality and builds sustainable digital solutions.
                </p>
              </div>

              <div className="about-card">
                <h3>Our Values</h3>
                <p>
                  Innovation, integrity, collaboration, and excellence guide everything
                  we do.
                </p>
              </div>
            </div>

            <BlackRothAnimation />

            <div className="about-story" ref={storyRef}>
              <div className="story-content">
                <h3 className="story-title">Our Story</h3>
                <p className="story-text-1">
                  <span className="brand-name">BlackRoth</span> was founded with a passion for technology and a bold vision for the future.
                  We are dedicated to redefining the technology landscape through creativity, expertise, and an unwavering focus on delivering exceptional value to our clients.
                </p>
                <p className="story-text-2">
                  Our approach combines strategic insight, agile execution,
                  and advanced solutions that empower organizations to overcome complex challenges and position themselves for long-term success in an ever-evolving digital world.
                </p>
              </div>

              <div className="story-image">
                <img src="https://blackroth-images.s3.ap-south-1.amazonaws.com/blackRoth..jpg" alt="BlackRoth Team" />
              </div>
            </div>

            <div className="story-scroll-section" aria-hidden="true">
              <div className="story-scroll-window">
                <div className="story-scroll-track">
                  <div className="story-scroll-group">
                    <span>Build your software with BlackRoth</span>
                    <span>Build your software with BlackRoth</span>
                    <span>Build your software with BlackRoth</span>
                    <span>Build your software with BlackRoth</span>
                    <span>Build your software with BlackRoth</span>
                    <span>Build your software with BlackRoth</span>
                  </div>
                  <div className="story-scroll-group">
                    <span>Build your software with BlackRoth</span>
                    <span>Build your software with BlackRoth</span>
                    <span>Build your software with BlackRoth</span>
                    <span>Build your software with BlackRoth</span>
                    <span>Build your software with BlackRoth</span>
                    <span>Build your software with BlackRoth</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Expertise Section - Now Outside story div */}
            <div className="about-expertise">
              <h3>Why choose BlackRoth?</h3>
              <div className="expertise-grid">
                <div
                  className="expertise-item expertise-item--magnetic"
                  onMouseMove={updateExpertisePointer}
                  onMouseLeave={resetExpertisePointer}
                >
                  <h4>Deep Technical Expertise</h4>
                  <p>
                    Our team consists of industry veterans and rising stars with deep expertise across a wide range of technologies and industries.
                  </p>
                </div>
                <div
                  className="expertise-item expertise-item--tilt-glow"
                  onMouseMove={updateExpertisePointer}
                  onMouseLeave={resetExpertisePointer}
                >
                  <h4>Perspectives & Innovation</h4>
                  <p>Bringing new ideas and modern approaches to solve complex challenges with creative, out-of-the-box thinking.</p>
                </div>
                <div
                  className="expertise-item expertise-item--split-reveal"
                  onMouseMove={updateExpertisePointer}
                  onMouseLeave={resetExpertisePointer}
                >
                  <h4>Innovation-Driven approach</h4>
                  <p>We stay ahead of technology trends, ensuring our solutions are future-proof and cutting-edge.</p>
                </div>
                <div
                  className="expertise-item expertise-item--particle-float"
                  onMouseMove={updateExpertisePointer}
                  onMouseLeave={resetExpertisePointer}
                >
                  <h4>Next-Gen Agility</h4>
                  <p>Fast-paced, flexible approach that adapts quickly to changing requirements and delivers results efficiently.</p>
                </div>
                <div
                  className="expertise-item expertise-item--neon-outline"
                  onMouseMove={updateExpertisePointer}
                  onMouseLeave={resetExpertisePointer}
                >
                  <h4>Client-Centric Focus</h4>
                  <p>Your success is our priority. We work closely with clients to understand their unique challenges and goals.</p>
                </div>
                <div
                  className="expertise-item expertise-item--flip-depth"
                  onMouseMove={updateExpertisePointer}
                  onMouseLeave={resetExpertisePointer}
                >
                  <h4>24/7 Support & Maintenance</h4>
                  <p>Round-the-clock support and proactive maintenance to ensure your systems run smoothly and efficiently.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Homepages;






